/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import appRoutes from './app'
import auth from './app/auth'
import { getUserRole, isActiveToken, logoutUser } from '../helpers/utils'
Vue.use(Router)


const routes = [
  ...auth,
  ...appRoutes,
  
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.redirectIfLoggedIn && isActiveToken()) {
    next('/')
  }
  if (to.matched.some(m => m.meta.role === 'OWNER') && getUserRole() !== 'OWNER') {
    next({
      path: '/become-a-owner',
      query: { redirect: to.fullPath }
    })
  }
  if (to.matched.some(m => m.meta.authRequired) && !isActiveToken()) {
    logoutUser()
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
 
  next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
